import { useLenis } from "../hooks/useLenis";
import { NoiseOverlay } from "../components/site/NoiseOverlay";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { DividerMarquee } from "../components/site/DividerMarquee";
import { Laboratory } from "../components/site/Laboratory";
import { Academy } from "../components/site/Academy";
import { Cockpit } from "../components/site/Cockpit";
import { Marketplace } from "../components/site/Marketplace";
import { Pricing } from "../components/site/Pricing";
import { CreditsPacks } from "../components/site/CreditsPacks";
import { Community } from "../components/site/Community";
import { Products } from "../components/site/Products";
import { Vision } from "../components/site/Vision";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { GatedSection } from "../components/site/GatedSection";

export default function Home() {
  useLenis();
  return (
    <div className="relative min-h-screen bg-[#0F172A]" data-testid="home-page">
      <div className="lab-fixed-bg" aria-hidden="true" />
      <NoiseOverlay />
      <div className="relative z-10">
        <Nav />
        <main>
          <Hero />
          <DividerMarquee />
          <GatedSection title="Le Laboratoire AIBA" subtitle="Aperçu de nos créations IA. Inscrivez-vous gratuitement pour explorer le laboratoire.">
            <Laboratory />
          </GatedSection>
          <GatedSection title="L'Académie AIBA" subtitle="8 formations pour maîtriser l'IA business. Créez votre compte pour y accéder.">
            <Academy />
          </GatedSection>
          <GatedSection title="Les 10 outils IA" subtitle="Writer, Chat, Voice, Clone, Vidéo… débloquez le cockpit complet en vous inscrivant.">
            <Cockpit />
          </GatedSection>
          <GatedSection title="La Marketplace AIBA" subtitle="Achetez et vendez des produits IA. Inscrivez-vous pour découvrir le catalogue.">
            <Marketplace />
          </GatedSection>
          <Pricing />
          <CreditsPacks />
          <GatedSection title="Produits numériques" subtitle="Des centaines de créations à explorer. Créez votre compte gratuit pour les débloquer.">
            <Products />
          </GatedSection>
          <GatedSection title="La Communauté AIBA" subtitle="Rejoignez les créateurs IA. Inscrivez-vous pour voir et publier dans la communauté.">
            <Community />
          </GatedSection>
          <Vision />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}
